module.exports = __webpack_public_path__ + "img/milad-fakurian-PjG_SXDkpwQ-unsplash.3718a219.png";